var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReffrralBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 813,
    height: 813,
    viewBox: "0 0 813 813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3261be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#032058"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_395",
    "data-name": "Ellipse 395",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 406.5,
    cy: 406.5,
    r: 406.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.5,
    cy: 406.5,
    r: 406,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReffrralBg);
export default __webpack_public_path__ + "static/media/reffrral-bg.98e11024a5b420cf250187244cfd8f4f.svg";
export { ForwardRef as ReactComponent };